<template>
  <div>
    <CCard>
      <CCardHeader>
        <h2>休暇申請詳細</h2>
      </CCardHeader>
      <CCardBody>
        <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table">
                <tr><th scope="row">申請日</th><td>{{ submission_at }}</td></tr>
                <tr><th scope="row">プロジェクト名</th><td>{{ project_name }}</td></tr>
                <tr><th scope="row">種別</th><td><span>{{ getTypeName(type) }}</span></td></tr>
                <tr><th scope="row">開始日</th><td>{{ formatDate(start_day) }}【{{ getDayName(start_time) }}】</td></tr>
                <tr>
                  <th scope="row">終了日</th>
                  <td>{{ endLabel }}</td>
                </tr>
                <tr><th scope="row">備考・事由など</th><td>{{ reason }}</td></tr>
                <tr><th scope="row">休暇中の緊急連絡先</th><td>{{ telephone }}</td></tr>
                <tr>
                  <th scope="row">事前連絡済</th>
                  <td>
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-2">
                        <label class="custom-switch mb-0">
                          <input type="checkbox" class="custom-switch-input" id="mgr-approved" v-model="manager_approval" disabled>
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="mgr-approved" class="ml-2 mb-0">社内報告先</label>
                      </div>
                      <div class="d-flex align-items-center">
                        <label class="custom-switch mb-0">
                          <input type="checkbox" class="custom-switch-input" id="sup-approved" v-model="supervisor_approval" disabled>
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="sup-approved" class="ml-2 mb-0">現場・社外報告先</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <router-link :to="{ name: paidAndSudstituteList }">
                    <button class="btn btn-secondary">戻る</button>
                  </router-link>
                </CCol>
                <CCol class="text-center">
                  <!-- 承認待ち・承認済みは直せないので［編集］を出さず、取り消し方を出す（束5）。 -->
                  <router-link v-if="canEdit(status)" :to="{ name: paidAndSudstituteEdit, params: { id: $route.params.id } }">
                    <button class="btn btn-info">編集</button>
                  </router-link>
                  <p v-else class="preika-leave-cancel-guide text-muted mb-0">{{ leaveCancelGuide(status) }}</p>
                </CCol>
                <CCol></CCol>
              </CRow>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from 'axios'
import ConstList from '../../ConstList'
import { safeErrorDigest } from '../../utils/safeResponseMessage'
import { leaveCancelGuide, leaveIsEditable } from './leaveCancelGuide'
import { leaveTypeName } from '../../utils/leaveTypeName'

export default {
  name: 'PaidAndSubstitute',
  data () {
    return {
      updated_at: '',
      // 申請した日（提出の申請日時）。未申請なら空（束5）。
      submission_at: '',
      // 承認の状態。取れるまでは空（［編集］を出す側に倒さないよう、下で判定する）。
      status: null,
      project_name: '',
      type: '',
      start_day: '',
      start_time: '',
      end_day: '',
      end_time: '',
      days: [
        { id: ConstList.ALLDAY_ID, name: ConstList.ALLDAY },
        { id: ConstList.MORNING_ID, name: ConstList.MORNING },
        { id: ConstList.AFTERNOON_ID, name: ConstList.AFTERNOON }
      ],
      reason: '',
      telephone: '',
      approval_type: '',
      manager_approval: false,
      supervisor_approval: false,
      errorMessage: '',
      paidAndSudstituteList: ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST,
      paidAndSudstituteEdit: ConstList.ROUTE_PAIDANDSUDSTITUTE_EDIT
    }
  },
  computed: {
    endLabel () {
      if (this.end_day != null && this.end_time != null &&
          (this.start_day !== this.end_day || this.start_time !== this.end_time)) {
        return `${this.formatDate(this.end_day)}【${this.getDayName(this.end_time)}】`
      }
      return '単日取得'
    }
  },
  mounted () {
    const id = Number(this.$route.params.id)
    if (!Number.isSafeInteger(id) || id <= 0) {
      this.errorMessage = '休暇申請を特定できませんでした。一覧から選択し直してください。'
      return
    }
    axios
      .get(`${process.env.VUE_APP_API_ORIGIN}/paidandsubstitute/${id}`)
      .then(response => {
        if (!response.data) {
          this.errorMessage = ConstList.RECORD_NOT_FOUND
          return
        }
        const userData = response.data
        this.project_name = userData.project_name
        this.start_day = userData.start_day
        this.start_time = userData.start_time
        this.end_day = userData.end_day
        this.end_time = userData.end_time
        this.type = userData.type
        this.updated_at = userData.updated_at
        this.submission_at = userData.submission_at || ''
        this.status = userData.status || ''
        this.reason = userData.reason
        this.telephone = userData.telephone
        this.approval_type = userData.approval_type
        this.manager_approval = [ConstList.MANAGER_APPROVAL_ID, ConstList.BOTH_APPROVAL_ID].includes(this.approval_type)
        this.supervisor_approval = [ConstList.SUPERVISOR_APPROVAL_ID, ConstList.BOTH_APPROVAL_ID].includes(this.approval_type)
      })
      .catch(error => {
        this.errorMessage = '休暇申請を取得できませんでした。画面を再読み込みしてください。'
        console.error('休暇申請詳細取得失敗:', safeErrorDigest(error))
      })
  },
  methods: {
    canEdit (status) {
      // 状態が取れるまで（null）は［編集］を出さない。
      return status !== null && leaveIsEditable(status)
    },
    leaveCancelGuide,
    // 種別の番号 → 呼び名。一覧と同じ対応を使う（番号を画面に出さない）。
    getTypeName (id) {
      return leaveTypeName(id)
    },
    formatDate (dateStr) {
      if (!dateStr) return ''
      const [yyyy, mm, dd] = dateStr.split('-')
      return `${yyyy}/${mm}/${dd}`
    },
    getDayName (id) {
      const option = this.days.find(value => value.id === id)
      return option ? option.name : id
    }
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
/*
 * 取り消し方の1行。一覧の同じ案内と同じ考えで、語の途中では折らない
 * （前は「編／集・削除ができます。」と切れていた）。折り返すのは読点・かっこの所だけ。
 * どうしても入らない幅のときだけ、はみ出さないよう途中で折る。
 */
.preika-leave-cancel-guide {
  word-break: keep-all;
  overflow-wrap: anywhere;
}
</style>
